import React from "react";
import Navbar from "./Navbar";
import KeyFeatures from "./KeyFeatures";
import WhyUs from "./WhyUs";
import SchoolERP from "./Erp";
import AdmissionManagement from "./AdmissionManagement";
import LearningManagement from "./LearningManagement";
import ExaminationSoftware from "./ExaminationSoftware";
import WebsiteMobileApp from "./Website&Mobile";
import AboutUs from "./AboutUs";
import OurMission from "./OurMission";
import Vision from "./Vision";
import ContactUs from "./ContactUs";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";
import DownloadApp from "./DownloadApp";
import { FaGooglePlay, FaApple } from "react-icons/fa";

const HomePage = () => {
  const navigate = useNavigate();

  // 🔁 Replace these URLs with your actual store links
  const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.posternova.posternova";
  const APP_STORE_URL = "https://apps.apple.com/in/app/editezy/id6753908761"; // update with real link

  return (
    <div>
      {/* Static Navbar */}
      <div className="fixed top-0 left-0 right-0 z-50">
        <Navbar />
      </div>

      {/* Hero Section */}
      <section
        id="home"
        className="bg-white flex flex-col lg:flex-row justify-between items-center px-6 py-12 mt-24"
      >
        {/* Left Side Text */}
        <div className="text-gray-800 w-full max-w-lg mb-6 lg:mb-0">
          <h1 className="text-3xl font-bold mb-4 ml-4">
            Welcome to <span className="text-purple-700">EDIT EZY</span>
          </h1>
          <p className="text-lg mb-3 ml-4">
            The easiest way to create, edit, and download your own{" "}
            <span className="font-bold">Posters</span> &{" "}
            <span className="font-bold">Business Cards</span>.
          </p>
          <p className="text-lg mb-3 ml-4">
            With{" "}
            <span className="font-bold text-purple-700">EDIT EZY</span>, you
            can now design stunning posters and business cards for any occasion,
            including birthday, anniversary events, promotional activities, or
            business purposes.
          </p>
          <p className="text-lg ml-4">
            Our easy-to-use editor allows you to customize templates, add your
            own text, images, and logos, and instantly download high-quality
            designs ready for printing.
          </p>

          {/* Store Buttons */}
          <div className="mt-8 ml-4 flex flex-col sm:flex-row gap-4">

            {/* Google Play Store */}
            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 px-5 py-3 rounded-2xl bg-gradient-to-r from-green-500 to-green-700 text-white hover:from-green-600 hover:to-green-800 transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-0.5 transform group w-fit"
            >
              <FaGooglePlay
                size={26}
                className="text-white group-hover:scale-110 transition-transform duration-200"
              />
              <div className="flex flex-col leading-tight">
                <span className="text-[10px] text-green-100 uppercase tracking-widest">
                  Get it on
                </span>
                <span className="text-base font-semibold">Google Play</span>
              </div>
            </a>

            {/* Apple App Store */}
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 px-5 py-3 rounded-2xl bg-gradient-to-r from-blue-500 to-blue-700 text-white hover:from-blue-600 hover:to-blue-800 transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-0.5 transform group w-fit"
            >
              <FaApple
                size={28}
                className="text-white group-hover:scale-110 transition-transform duration-200"
              />
              <div className="flex flex-col leading-tight">
                <span className="text-[10px] text-blue-100 uppercase tracking-widest">
                  Download on the
                </span>
                <span className="text-base font-semibold">App Store</span>
              </div>
            </a>

          </div>


        </div>

        {/* Right Side Image */}
        <div className="w-full max-w-xl">
          <img
            src="https://img.freepik.com/premium-vector/full-stack-developer-job-2d-illustration-concept_151150-27976.jpg"
            alt="EDIT EZY Feature"
            className="w-full h-auto object-contain rounded-lg"
          />
        </div>
      </section>

      {/* Other Sections */}
      <div>
        <hr className="border-t-2 border-gray-300" />
        <section id="features"><KeyFeatures /></section>
        <hr className="border-t-2 border-gray-300" />
        <section id="whyus"><WhyUs /></section>
        <hr className="border-t-2 border-gray-300" />
        <section id="schoolerp"><SchoolERP /></section>
        <hr className="border-t-2 border-gray-300" />
        <section id="aboutus"><AboutUs /></section>
        <hr className="border-t-2 border-gray-300" />
        <section id="ourmission"><OurMission /></section>
        <hr className="border-t-2 border-gray-300" />
        <section id="vision"><Vision /></section>
        <hr className="border-t-2 border-gray-300" />
        <section id="download"><DownloadApp /></section>
        <hr className="border-t-2 border-gray-300" />
        <section id="contactus"><ContactUs /></section>
        <hr className="border-t-2 border-gray-300" />
        <Footer />
      </div>
    </div>
  );
};

export default HomePage;